if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.content = this.querySelector('.product-media-modal__content');
        this.thumbs = Array.from(this.querySelectorAll('.product-media-modal__thumb'));
        this.counterCurrent = this.querySelector('[data-counter-current]');
        this.mediaItems = this.content
          ? Array.from(this.content.children).filter((el) => el.hasAttribute('data-media-id'))
          : [];
        this.currentIndex = 0;

        this.bindNav();
        this.bindThumbs();
        this.bindKeys();
        this.bindSwipe();
        this.bindBackdrop();
      }

      bindNav() {
        this.querySelectorAll('[data-direction]').forEach((btn) => {
          btn.addEventListener('click', (event) => {
            event.stopPropagation();
            this.navigate(btn.dataset.direction === 'next' ? 1 : -1);
          });
        });
      }

      bindThumbs() {
        this.thumbs.forEach((btn) => {
          btn.addEventListener('click', (event) => {
            event.stopPropagation();
            const idx = parseInt(btn.dataset.index, 10);
            if (!Number.isNaN(idx)) this.showAt(idx);
          });
        });
      }

      bindKeys() {
        this.addEventListener('keydown', (event) => {
          if (event.code === 'ArrowRight') {
            event.preventDefault();
            this.navigate(1);
          } else if (event.code === 'ArrowLeft') {
            event.preventDefault();
            this.navigate(-1);
          }
        });
      }

      bindSwipe() {
        if (!this.content) return;
        let startX = null;
        let startY = null;
        this.content.addEventListener(
          'touchstart',
          (event) => {
            const t = event.touches[0];
            startX = t.clientX;
            startY = t.clientY;
          },
          { passive: true }
        );
        this.content.addEventListener('touchend', (event) => {
          if (startX === null) return;
          if (this.isMobileLayout()) {
            startX = null;
            startY = null;
            return;
          }
          const t = event.changedTouches[0];
          const dx = t.clientX - startX;
          const dy = t.clientY - startY;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
            this.navigate(dx < 0 ? 1 : -1);
          }
          startX = null;
          startY = null;
        });
      }

      isMobileLayout() {
        return typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 749px)').matches;
      }

      bindBackdrop() {
        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });
        const dialog = this.querySelector('.product-media-modal__dialog');
        if (dialog) {
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) this.hide();
          });
        }
      }

      navigate(delta) {
        if (!this.mediaItems.length) return;
        const total = this.mediaItems.length;
        const next = (this.currentIndex + delta + total) % total;
        this.showAt(next);
      }

      show(opener) {
        super.show(opener);
        let startIndex = 0;
        const mediaId = opener && opener.getAttribute ? opener.getAttribute('data-media-id') : null;
        if (mediaId) {
          const idx = this.mediaItems.findIndex((el) => el.getAttribute('data-media-id') === mediaId);
          if (idx >= 0) startIndex = idx;
        }
        this.showAt(startIndex);
      }

      showAt(index) {
        if (!this.mediaItems.length) return;
        this.currentIndex = index;
        const activeMedia = this.mediaItems[index];
        const mobile = this.isMobileLayout();

        this.mediaItems.forEach((el) => {
          el.classList.toggle('active', el === activeMedia);
        });

        if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }

        const tpl = activeMedia.querySelector('template');
        const isYoutube = tpl && tpl.content && tpl.content.querySelector('.js-youtube');
        if (activeMedia.nodeName === 'DEFERRED-MEDIA' && isYoutube && activeMedia.loadContent) {
          activeMedia.loadContent();
        }

        this.thumbs.forEach((btn) => {
          const isActive = btn.dataset.index === String(index);
          btn.setAttribute('aria-current', isActive ? 'true' : 'false');
          btn.classList.toggle('is-active', isActive);
          if (isActive && !mobile && typeof btn.scrollIntoView === 'function') {
            btn.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        });

        if (this.counterCurrent) {
          this.counterCurrent.textContent = String(index + 1);
        }

        // On mobile the modal is a vertical stack — scroll the dialog so the
        // clicked image lands at the top instead of forcing a single-slide view.
        if (mobile) {
          requestAnimationFrame(() => {
            if (typeof activeMedia.scrollIntoView === 'function') {
              activeMedia.scrollIntoView({ block: 'start', behavior: 'auto' });
            }
          });
        }
      }
    }
  );
}
